import {Script} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import {Scripts} from '@/utils/external-scripts'
import {Section} from '@helios/shared/styles/grid'
import mq from '@helios/shared/utils/media-query'

export const DatevBanner = () => {
    return (
        <>
            <Script
                src={Scripts.DATEV_MARKETING}
                onError={() => console.error(`Datev script failed to load.`)}
            />
            <StyledSection padding="small">
                <div id="mym-insert-here-84343" />
            </StyledSection>
        </>
    )
}

const StyledSection = styled(Section)`
    display: flex;
    justify-content: center;

    svg {
        min-width: 300px !important;
    }

    ${mq.min('md')} {
        padding-top: 0;
        padding-bottom: 80px;
    }
`
